import { render, staticRenderFns } from "./LessonShowCopy.vue?vue&type=template&id=4c8b2b88&"
import script from "./LessonShowCopy.vue?vue&type=script&lang=js&"
export * from "./LessonShowCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports